import { LabelSelectionGroup, LabelType } from '../../../../store';

export function buildSavedSelectionGroups(
  groups: LabelSelectionGroup[],
  name: string,
  selectedIds: string[],
  color: string,
) {
  if (!name || selectedIds.length === 0) {
    return null;
  }

  return [
    ...groups.filter((group) => group.name !== name),
    { name, labelIds: selectedIds, color },
  ].sort((left, right) => left.name.localeCompare(right.name));
}

export function resolveCurrentGroupStyleTargetIds(
  allLabels: LabelType[],
  group: LabelSelectionGroup | null,
) {
  if (!group) {
    return [];
  }

  const availableIds = new Set(allLabels.map((label) => label.id));
  return group.labelIds.filter((labelId) => availableIds.has(labelId));
}
